import axios from "axios"

const checkAuth = () => {
/*  Getting token value stored in localstorage, if token is not present we will open login page 
    for all internal dashboard routes  */
    const TOKEN = localStorage.getItem("token")
    const PUBLIC_ROUTES = ["login", "forgot-password", "reset-password", "register", "documentation"]

    const isPublicPage = PUBLIC_ROUTES.some( r => window.location.href.includes(r))

    // Check if token exists and is not empty/null
    if(!TOKEN || TOKEN.trim() === '' || TOKEN === 'null' || TOKEN === 'undefined'){
        if (!isPublicPage) {
            // Clear any invalid token
            localStorage.removeItem('token');
            window.location.href = '/login'
            return null;
        }
        return null;
    } else {
        // Set authorization header for axios
        axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`

        axios.interceptors.request.use(function (config) {
            // UPDATE: Add this code to show global loading indicator
            document.body.classList.add('loading-indicator');
            return config
          }, function (error) {
            return Promise.reject(error);
          });
          
          axios.interceptors.response.use(function (response) {
            // UPDATE: Add this code to hide global loading indicator
            document.body.classList.remove('loading-indicator');
            return response;
          }, function (error) {
            document.body.classList.remove('loading-indicator');
            
            // Handle 401 Unauthorized - token expired or invalid
            if (error.response?.status === 401) {
                localStorage.removeItem('token');
                if (!isPublicPage) {
                    window.location.href = '/login';
                }
            }
            
            return Promise.reject(error);
          });
        return TOKEN
    }
}

export default checkAuth